import { Box, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickAccessWidget = ({ actions = [] }) => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '1rem',
          fontWeight: 700,
          color: '#0F172A',
          mb: 2,
          letterSpacing: '-0.01em',
        }}
      >
        Accesos Rápidos
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: `repeat(${Math.max(actions.length, 1)}, 1fr)`,
          },
          gap: 2,
        }}
      >
        {actions.map((action, index) => (
          <Box
            key={index}
            onClick={() => navigate(action.path)}
            sx={{
              bgcolor: '#ffffff',
              borderRadius: '14px',
              p: 2.25,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              transition: 'all 0.2s ease',
              '&:hover': {
                borderColor: action.color,
                boxShadow: `0 4px 20px ${action.color}22`,
                transform: 'translateY(-2px)',
                '& .quick-arrow': {
                  opacity: 1,
                  transform: 'translateX(0)',
                },
                '& .quick-icon-box': {
                  bgcolor: action.color,
                  '& svg': { color: '#ffffff' },
                },
              },
            }}
          >
            <Box
              className="quick-icon-box"
              sx={{
                width: 46,
                height: 46,
                borderRadius: '12px',
                bgcolor: `${action.color}12`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                transition: 'background-color 0.2s ease',
                '& svg': {
                  fontSize: 22,
                  color: action.color,
                  transition: 'color 0.2s ease',
                },
              }}
            >
              {action.icon}
            </Box>

            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontSize: '0.9rem',
                  fontWeight: 700,
                  color: '#0F172A',
                  letterSpacing: '-0.01em',
                  lineHeight: 1.3,
                }}
              >
                {action.title}
              </Typography>
              {action.badge && (
                <Typography sx={{ fontSize: '0.73rem', color: '#94A3B8', mt: 0.25, fontWeight: 500 }}>
                  {action.badge}
                </Typography>
              )}
            </Box>

            <ArrowForward
              className="quick-arrow"
              sx={{
                fontSize: 17,
                color: action.color,
                opacity: 0,
                transform: 'translateX(-6px)',
                transition: 'all 0.2s ease',
                flexShrink: 0,
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default QuickAccessWidget;
